let keyboardFocusState = false;
const KEYBOARD_FOCUS_CLASS = 'keyfocus';
const KEYBOARD_CODE_TAB = 'Tab';

/**
 * Handle logic to change state to keyboard navigation.
 */
function onFocusInHandler() {
  keyboardFocusState = true;
  document.body.classList.add(KEYBOARD_FOCUS_CLASS);
  document.body.removeEventListener('focusin', onFocusInHandler);
}

/**
 * Handle logic to remove keyboard navigation state after onTabKeyPress to default.
 */
function onClickHandler() {
  keyboardFocusState = false;
  document.body.classList.remove(KEYBOARD_FOCUS_CLASS);
  document.body.removeEventListener('click', onClickHandler);
}

/**
 * Main logic: call differ actions onTabKeyPress and onClick
 */
function smartKeyboardFocus() {
  document.addEventListener('keydown', (event) => {
    if (event.key !== KEYBOARD_CODE_TAB || keyboardFocusState) { return; }
    document.body.addEventListener('focusin', onFocusInHandler);
    document.body.addEventListener('click', onClickHandler);
  });
}

smartKeyboardFocus();
